import { combineReducers } from 'redux';
import AddIntegration from './admin/AddIntegration';
import AddTeamMember from './admin/AddTeamMember';
import IntegrationList from './admin/IntegrationList';
import Invites from './Invites';
import Join from './Join';
import Login from './Login';
import PhoneVerification from './PhoneVerification';
import ProcessList from './ProcessList';
import Profile from './Profile';
import RunList from './Run/RunList';
import Team from './Team';
import SingleIntegration from './admin/SingleIntegration';
import StartRun from './StartRun';
import tasks from './tasks';
import TeamList from './admin/TeamList';
import Webform from './Webform';
import XIntegrationList from './XIntegrationList';
import XLogin from './XLogin';
import XProfile from './XProfile';

export default combineReducers({
  AddIntegration,
  AddTeamMember,
  IntegrationList,
  Invites,
  Join,
  Login,
  PhoneVerification,
  ProcessList,
  Profile,
  RunList,
  SingleIntegration,
  StartRun,
  tasks,
  Team,
  TeamList,
  Webform,
  XIntegrationList,
  XLogin,
  XProfile
});



// WEBPACK FOOTER //
// ./js/reducers/page/index.js